export const inputValueMatch = <T>(
  options: T[],
  optionsKey: string,
  inputValue: string,
) => {
  return options.some((o) => (o as any)[optionsKey] === inputValue);
};
